export interface CorreoElectronico {
  id: number;
  tipo_correo_id: number; // id TipoCorreo
  direccion: string;
}

export function createEmptyCorreoElectronico(): CorreoElectronico {
  return {
    id: null,
    tipo_correo_id: null, // id TipoCorreo
    direccion: null
  };
}

export function createCorreoElectronico(params: any): CorreoElectronico {
  return {
    ...createEmptyCorreoElectronico(),
    ...params
  };
}
